import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { find, isNil } from 'ramda';

import styles from './styles.m.scss';

import certificationImg from '../../../images/certification-icon.png';
import registrationImg from '../../../images/courses.png';
import membershipImg from '../../../images/membership-icon.png';

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  compact: PropTypes.bool,
  divider: PropTypes.bool,
  flex: PropTypes.bool,

  certification: PropTypes.bool,
  registration: PropTypes.bool,
  membership: PropTypes.bool,
};

const Header = ({ children, className, compact, divider, certification, flex, registration, membership }) => {
  const headerClasses = cn('card-header', className, {
    [styles.compact]: compact,
    [styles.divider]: divider,
  });
  const imgSrc = find((image) => !isNil(image), [
    certification ? certificationImg : null,
    registration ? registrationImg : null,
    membership ? membershipImg : null,
  ]);

  return (
    <div className={cn(headerClasses, 'd-flex')}>
      <div className={cn('flex-grow-1', { 'd-flex': flex })}>{children}</div>
      {imgSrc && <img className={styles.headerImage} src={imgSrc} />}
    </div>
  );
};

Header.propTypes = propTypes;

export default Header;
